/**
 * World countries reference (ISO 3166-1 alpha-2) with phone dial codes.
 * Mirrors backend/apps/domains/data/countries.py — keep both in sync.
 * Flag is derived from the ISO code (regional indicator symbols), so no
 * image assets are needed and it renders natively on all platforms.
 */

const RAW = [
  ['AD', 'Andorra', '+376'],
  ['AE', 'United Arab Emirates', '+971'],
  ['AF', 'Afghanistan', '+93'],
  ['AG', 'Antigua and Barbuda', '+1268'],
  ['AI', 'Anguilla', '+1264'],
  ['AL', 'Albania', '+355'],
  ['AM', 'Armenia', '+374'],
  ['AO', 'Angola', '+244'],
  ['AR', 'Argentina', '+54'],
  ['AS', 'American Samoa', '+1684'],
  ['AT', 'Austria', '+43'],
  ['AU', 'Australia', '+61'],
  ['AW', 'Aruba', '+297'],
  ['AZ', 'Azerbaijan', '+994'],
  ['BA', 'Bosnia and Herzegovina', '+387'],
  ['BB', 'Barbados', '+1246'],
  ['BD', 'Bangladesh', '+880'],
  ['BE', 'Belgium', '+32'],
  ['BF', 'Burkina Faso', '+226'],
  ['BG', 'Bulgaria', '+359'],
  ['BH', 'Bahrain', '+973'],
  ['BI', 'Burundi', '+257'],
  ['BJ', 'Benin', '+229'],
  ['BM', 'Bermuda', '+1441'],
  ['BN', 'Brunei', '+673'],
  ['BO', 'Bolivia', '+591'],
  ['BR', 'Brazil', '+55'],
  ['BS', 'Bahamas', '+1242'],
  ['BT', 'Bhutan', '+975'],
  ['BW', 'Botswana', '+267'],
  ['BY', 'Belarus', '+375'],
  ['BZ', 'Belize', '+501'],
  ['CA', 'Canada', '+1'],
  ['CD', 'DR Congo', '+243'],
  ['CF', 'Central African Republic', '+236'],
  ['CG', 'Congo', '+242'],
  ['CH', 'Switzerland', '+41'],
  ['CI', "Cote d'Ivoire", '+225'],
  ['CK', 'Cook Islands', '+682'],
  ['CL', 'Chile', '+56'],
  ['CM', 'Cameroon', '+237'],
  ['CN', 'China', '+86'],
  ['CO', 'Colombia', '+57'],
  ['CR', 'Costa Rica', '+506'],
  ['CU', 'Cuba', '+53'],
  ['CV', 'Cape Verde', '+238'],
  ['CW', 'Curacao', '+599'],
  ['CY', 'Cyprus', '+357'],
  ['CZ', 'Czechia', '+420'],
  ['DE', 'Germany', '+49'],
  ['DJ', 'Djibouti', '+253'],
  ['DK', 'Denmark', '+45'],
  ['DM', 'Dominica', '+1767'],
  ['DO', 'Dominican Republic', '+1809'],
  ['DZ', 'Algeria', '+213'],
  ['EC', 'Ecuador', '+593'],
  ['EE', 'Estonia', '+372'],
  ['EG', 'Egypt', '+20'],
  ['ER', 'Eritrea', '+291'],
  ['ES', 'Spain', '+34'],
  ['ET', 'Ethiopia', '+251'],
  ['FI', 'Finland', '+358'],
  ['FJ', 'Fiji', '+679'],
  ['FK', 'Falkland Islands', '+500'],
  ['FM', 'Micronesia', '+691'],
  ['FO', 'Faroe Islands', '+298'],
  ['FR', 'France', '+33'],
  ['GA', 'Gabon', '+241'],
  ['GB', 'United Kingdom', '+44'],
  ['GD', 'Grenada', '+1473'],
  ['GE', 'Georgia', '+995'],
  ['GF', 'French Guiana', '+594'],
  ['GH', 'Ghana', '+233'],
  ['GI', 'Gibraltar', '+350'],
  ['GL', 'Greenland', '+299'],
  ['GM', 'Gambia', '+220'],
  ['GN', 'Guinea', '+224'],
  ['GP', 'Guadeloupe', '+590'],
  ['GQ', 'Equatorial Guinea', '+240'],
  ['GR', 'Greece', '+30'],
  ['GT', 'Guatemala', '+502'],
  ['GU', 'Guam', '+1671'],
  ['GW', 'Guinea-Bissau', '+245'],
  ['GY', 'Guyana', '+592'],
  ['HK', 'Hong Kong', '+852'],
  ['HN', 'Honduras', '+504'],
  ['HR', 'Croatia', '+385'],
  ['HT', 'Haiti', '+509'],
  ['HU', 'Hungary', '+36'],
  ['ID', 'Indonesia', '+62'],
  ['IE', 'Ireland', '+353'],
  ['IL', 'Israel', '+972'],
  ['IN', 'India', '+91'],
  ['IQ', 'Iraq', '+964'],
  ['IR', 'Iran', '+98'],
  ['IS', 'Iceland', '+354'],
  ['IT', 'Italy', '+39'],
  ['JM', 'Jamaica', '+1876'],
  ['JO', 'Jordan', '+962'],
  ['JP', 'Japan', '+81'],
  ['KE', 'Kenya', '+254'],
  ['KG', 'Kyrgyzstan', '+996'],
  ['KH', 'Cambodia', '+855'],
  ['KI', 'Kiribati', '+686'],
  ['KM', 'Comoros', '+269'],
  ['KN', 'Saint Kitts and Nevis', '+1869'],
  ['KP', 'North Korea', '+850'],
  ['KR', 'South Korea', '+82'],
  ['KW', 'Kuwait', '+965'],
  ['KY', 'Cayman Islands', '+1345'],
  ['KZ', 'Kazakhstan', '+7'],
  ['LA', 'Laos', '+856'],
  ['LB', 'Lebanon', '+961'],
  ['LC', 'Saint Lucia', '+1758'],
  ['LI', 'Liechtenstein', '+423'],
  ['LK', 'Sri Lanka', '+94'],
  ['LR', 'Liberia', '+231'],
  ['LS', 'Lesotho', '+266'],
  ['LT', 'Lithuania', '+370'],
  ['LU', 'Luxembourg', '+352'],
  ['LV', 'Latvia', '+371'],
  ['LY', 'Libya', '+218'],
  ['MA', 'Morocco', '+212'],
  ['MC', 'Monaco', '+377'],
  ['MD', 'Moldova', '+373'],
  ['ME', 'Montenegro', '+382'],
  ['MG', 'Madagascar', '+261'],
  ['MH', 'Marshall Islands', '+692'],
  ['MK', 'North Macedonia', '+389'],
  ['ML', 'Mali', '+223'],
  ['MM', 'Myanmar', '+95'],
  ['MN', 'Mongolia', '+976'],
  ['MO', 'Macau', '+853'],
  ['MQ', 'Martinique', '+596'],
  ['MR', 'Mauritania', '+222'],
  ['MS', 'Montserrat', '+1664'],
  ['MT', 'Malta', '+356'],
  ['MU', 'Mauritius', '+230'],
  ['MV', 'Maldives', '+960'],
  ['MW', 'Malawi', '+265'],
  ['MX', 'Mexico', '+52'],
  ['MY', 'Malaysia', '+60'],
  ['MZ', 'Mozambique', '+258'],
  ['NA', 'Namibia', '+264'],
  ['NC', 'New Caledonia', '+687'],
  ['NE', 'Niger', '+227'],
  ['NG', 'Nigeria', '+234'],
  ['NI', 'Nicaragua', '+505'],
  ['NL', 'Netherlands', '+31'],
  ['NO', 'Norway', '+47'],
  ['NP', 'Nepal', '+977'],
  ['NR', 'Nauru', '+674'],
  ['NU', 'Niue', '+683'],
  ['NZ', 'New Zealand', '+64'],
  ['OM', 'Oman', '+968'],
  ['PA', 'Panama', '+507'],
  ['PE', 'Peru', '+51'],
  ['PF', 'French Polynesia', '+689'],
  ['PG', 'Papua New Guinea', '+675'],
  ['PH', 'Philippines', '+63'],
  ['PK', 'Pakistan', '+92'],
  ['PL', 'Poland', '+48'],
  ['PR', 'Puerto Rico', '+1787'],
  ['PS', 'Palestine', '+970'],
  ['PT', 'Portugal', '+351'],
  ['PW', 'Palau', '+680'],
  ['PY', 'Paraguay', '+595'],
  ['QA', 'Qatar', '+974'],
  ['RE', 'Reunion', '+262'],
  ['RO', 'Romania', '+40'],
  ['RS', 'Serbia', '+381'],
  ['RU', 'Russia', '+7'],
  ['RW', 'Rwanda', '+250'],
  ['SA', 'Saudi Arabia', '+966'],
  ['SB', 'Solomon Islands', '+677'],
  ['SC', 'Seychelles', '+248'],
  ['SD', 'Sudan', '+249'],
  ['SE', 'Sweden', '+46'],
  ['SG', 'Singapore', '+65'],
  ['SI', 'Slovenia', '+386'],
  ['SK', 'Slovakia', '+421'],
  ['SL', 'Sierra Leone', '+232'],
  ['SM', 'San Marino', '+378'],
  ['SN', 'Senegal', '+221'],
  ['SO', 'Somalia', '+252'],
  ['SR', 'Suriname', '+597'],
  ['SS', 'South Sudan', '+211'],
  ['ST', 'Sao Tome and Principe', '+239'],
  ['SV', 'El Salvador', '+503'],
  ['SX', 'Sint Maarten', '+1721'],
  ['SY', 'Syria', '+963'],
  ['SZ', 'Eswatini', '+268'],
  ['TC', 'Turks and Caicos Islands', '+1649'],
  ['TD', 'Chad', '+235'],
  ['TG', 'Togo', '+228'],
  ['TH', 'Thailand', '+66'],
  ['TJ', 'Tajikistan', '+992'],
  ['TK', 'Tokelau', '+690'],
  ['TL', 'Timor-Leste', '+670'],
  ['TM', 'Turkmenistan', '+993'],
  ['TN', 'Tunisia', '+216'],
  ['TO', 'Tonga', '+676'],
  ['TR', 'Turkey', '+90'],
  ['TT', 'Trinidad and Tobago', '+1868'],
  ['TV', 'Tuvalu', '+688'],
  ['TW', 'Taiwan', '+886'],
  ['TZ', 'Tanzania', '+255'],
  ['UA', 'Ukraine', '+380'],
  ['UG', 'Uganda', '+256'],
  ['US', 'United States', '+1'],
  ['UY', 'Uruguay', '+598'],
  ['UZ', 'Uzbekistan', '+998'],
  ['VA', 'Vatican City', '+379'],
  ['VC', 'Saint Vincent and the Grenadines', '+1784'],
  ['VE', 'Venezuela', '+58'],
  ['VG', 'British Virgin Islands', '+1284'],
  ['VI', 'US Virgin Islands', '+1340'],
  ['VN', 'Vietnam', '+84'],
  ['VU', 'Vanuatu', '+678'],
  ['WF', 'Wallis and Futuna', '+681'],
  ['WS', 'Samoa', '+685'],
  ['XK', 'Kosovo', '+383'],
  ['YE', 'Yemen', '+967'],
  ['YT', 'Mayotte', '+262'],
  ['ZA', 'South Africa', '+27'],
  ['ZM', 'Zambia', '+260'],
  ['ZW', 'Zimbabwe', '+263'],
]

/** ISO alpha-2 code -> flag via Unicode regional indicator symbols. */
export function countryFlag(code) {
  const cc = (code || '').toUpperCase()
  if (!/^[A-Z]{2}$/.test(cc)) return ''
  return String.fromCodePoint(
    ...[...cc].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65),
  )
}

export const COUNTRIES = RAW
  .map(([code, name, dialCode]) => ({
    code,
    name,
    dialCode,
    flag: countryFlag(code),
  }))
  .sort((a, b) => a.name.localeCompare(b.name))

const BY_CODE = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]))

export function getCountry(code) {
  return BY_CODE[(code || '').toUpperCase()] || null
}

export function countryName(code) {
  return getCountry(code)?.name || code || ''
}
